export const defaultResourceReserveForm = {
  reserve_id: "",
  asset_id: "",
  name: "",
  mining_method: "",
  lifecycle: "na",
  lifecycle_stage: "",
  start_year_of_operation: "",
  expected_first_production_year: "",
  closure_or_reclamation_year: "",
  notes: "",
};

export const defaultResourceReportForm = {
  report_id: "",
  resource_reserve_id: "",
  as_of_date: "",
  estimate_period_unknown: false,
  source_title: "",
  source_url: "",
  source_notes: "",
};

export const defaultEconomicScenarioForm = {
  report_id: "",
  label: "",
  tax_treatment: "",
  discount_rate: "",
  irr_value: "",
  payback_period: "",
  currency: "USD",
  npv_value: "",
  notes: "",
};

export const defaultEconomicScenarioPriceRow = {
  commodity_id: "",
  price: "",
};
